import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import GlobalFilterPanel, { FILTER_PERIOD_GROUP, FIELDS as GlobalFilterPanelFields } from '../../filter/GlobalFilterPanel';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import DataMiningCommonFilterPanel from '../DataMiningCommonFilterPanel';
import Logger, { LOG_LEVELS } from '../../../utils/log';

const log = new Logger('DATA_MINING_INTRASTAT_LINES_FILTER_PANEL', LOG_LEVELS.DEBUG);

const DEFAULT_FILTER_SETTING = {
    filterPeriodGroup: FILTER_PERIOD_GROUP.DATE_RANGE,
    fieldOptions: {},
    hideElements: {
        month: true,
        year: true,
        countryCode: true,
        companyId: true,
        returnType: true,
        returnStatus: true
    }
};

export class IntrastatLinesFilterPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'Intrastat lines',
                startDate: '',
                endDate: '',
                sortAscending: false
            },
            filterSetting: DEFAULT_FILTER_SETTING
        };
        this.onReportChangeHandler = this.onReportChangeHandler.bind(this);
        this.onCheckboxChangeHandler = this.onCheckboxChangeHandler.bind(this);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    }

    onReportChangeHandler(selection = {}) {
        log.debug('onReportChangeHandler reportType', selection.reportType);
        this.props.onReportTypeChange(selection);
    }

    onCheckboxChangeHandler(evt) {
        let selection = Object.assign({}, this.state.selection);
        selection.sortAscending = !evt.target.checked;
        this.setState({
            selection: selection
        });
    }

    onSearchClickHandler(selection) {
        log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
        log.debug('onSearchClickHandler(): selection: ', selection);
        let existingSelection = Object.assign({}, this.state.selection);
        existingSelection.startDate = selection.startDate;
        existingSelection.endDate = selection.endDate;
        this.props.onSearchClick(existingSelection);
    }

    render() {
        log.debug('render() - props: ', this.props);
        let selection = this.state.selection || {};
        const filterSetting = this.state.filterSetting || DEFAULT_FILTER_SETTING;

        return (
            <div data-test="component-intrastat-lines-filter-panel">
                <s-box name="filter-panel">                   
                    <GlobalFilterPanel
                        {...filterSetting}
                        onSearchClick={this.onSearchClickHandler}>

                        <DataMiningCommonFilterPanel
                            reportType={this.state.selection.reportType}
                            onReportTypeChange={this.onReportChangeHandler}
                        />
                        <fieldset>
                            <legend><LanguageStringResolver string='dataMining_InvoiceLines_SortByDate' /></legend>
                            <span className="clear"></span>
                            <input
                                data-test="input-sort-by-date"
                                type="checkbox"
                                onChange={this.onCheckboxChangeHandler}
                                name="intrastatLinesSortByDate"
                                checked={!selection.sortAscending}
                            />
                            <label className="checkbox">Descending</label>
                        </fieldset>
                    </GlobalFilterPanel>
                    <div className="clear"></div>
                </s-box>
            </div>
        );
    }
}


IntrastatLinesFilterPanel.defaultProps = {
    onReportTypeChange: () => { },
    onSearchClick: () => { }
}

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    return dispatchProps;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(IntrastatLinesFilterPanel);